"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconKitchenwareThematic = void 0;
var React = __importStar(require("react"));
var IconKitchenwareThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M8,18 C11.309,18 14,15.309 14,12 C14,8.691 11.309,6 8,6 C4.691,6 2,8.691 2,12 C2,15.309 4.691,18 8,18 Z M8,5 C11.859,5 15,8.141 15,12 C15,15.859 11.859,19 8,19 C4.141,19 1,15.859 1,12 C1,8.141 4.141,5 8,5 Z M8,16 C10.206,16 12,14.206 12,12 C12,9.794 10.206,8 8,8 C5.794,8 4,9.794 4,12 C4,14.206 5.794,16 8,16 Z M8,7 C10.757,7 13,9.243 13,12 C13,14.757 10.757,17 8,17 C5.243,17 3,14.757 3,12 C3,9.243 5.243,7 8,7 Z M16.0049,9.167 C16.0009,9.154 16.4949,9.322 17.0749,9.527 L17.4079,9.646 L17.4079,18.5 C17.4079,18.776 17.1849,19 16.9079,19 C16.6319,19 16.4079,18.776 16.4079,18.5 L16.4079,10.352 C15.2529,9.938 14.9999,9.783 14.9999,9 L14.9999,5.5 C14.9999,5.224 15.2239,5 15.4999,5 C15.7759,5 15.9999,5.224 15.9999,5.5 L15.9999,9 C15.9999,9.067 15.9959,9.121 16.0049,9.167 Z M17,5 C17.276,5 17.5,5.224 17.5,5.5 L17.5,8.5 C17.5,8.776 17.276,9 17,9 C16.724,9 16.5,8.776 16.5,8.5 L16.5,5.5 C16.5,5.224 16.724,5 17,5 Z M18.5,5 C18.776,5 19,5.224 19,5.5 L19,8.5 C19,8.776 18.776,9 18.5,9 C18.224,9 18,8.776 18,8.5 L18,5.5 C18,5.224 18.224,5 18.5,5 Z M22.5,5 L23,5 L23,18.5 C23,18.776 22.776,19 22.5,19 C22.224,19 22,18.776 22,18.5 L22,6.987 C21.797,7.349 21.601,7.76 21.477,8.15 C21.258,8.844 21.159,9.731 21.219,10.051 C21.386,10.132 21.5,10.303 21.5,10.5 C21.5,10.776 21.276,11 21,11 C20.77,11 20.565,10.895 20.425,10.702 C19.879,9.958 20.517,7.87 20.523,7.85 C20.708,7.265 21.757,5 22.5,5 Z" }))); };
exports.IconKitchenwareThematic = IconKitchenwareThematic;
exports.IconKitchenwareThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconKitchenwareThematic;
